import { userLoginByPassword } from './login-by-password.service'

export const loginByPasswordOptions = () => ({
  queryKey: ['login-by-password'],
  queryFn: userLoginByPassword,
  enabled: false, // This is a mutation, not a query, so it should be disabled by default
})
